module.exports = __webpack_public_path__ + "static/media/User_Login_Icon.8356b5de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/User_Login_Icon.svg
// module id = 832
// module chunks = 0